import { AppBar, CircularProgress, Toolbar } from '@mui/material'
import React from 'react'
// import { Skeleton } from "@mui/lab";

const LoadingSkeletonComponent = (props: { showToolbar?: boolean }) => {
  return (
    <div>
      {props.showToolbar && (
        <AppBar style={{ backgroundColor: '#fff' }}>
          <Toolbar />
        </AppBar>
      )}
      <div
        style={{
          textAlign: 'center',
          margin: 'auto',
          maxWidth: '500px',
          padding: '20px',
          marginTop: '20px',
        }}
      >
        <CircularProgress size={15} />
        {/*  temporarily remove skeleton */}
        {/* <Skeleton /> */}
        {/* <Skeleton animation="wave" /> */}
        {/* <Skeleton animation={false} /> */}
        {/* <Skeleton animation="wave" /> */}
        {/* <Skeleton animation={false} /> */}
        {/* <Skeleton animation="wave" /> */}
        {/* <Skeleton animation={false} /> */}
      </div>
    </div>
  )
}

export default LoadingSkeletonComponent
